<template>
    <div>
        <div class="row">
            <div class="col-sm-12 overflow-auto">
                
                <b-table striped hover bordered :fields="fields" :items="data" :sort-compare="sortTable" responsive>
                    <template #cell(staff)="data">
                        <div class="row">
                            <div class="col-sm-12 text-center">
                                <img class="profile-image-md rounded-circle" :src="data.item.icon != '' ? getIcon(data.item.icon) : require('@/assets/image/icon/profile.png')"/>
                            </div>
                            <div class="mt-2 col-sm-12 text-center">
                                <p class="text-dark fw-700 fs-lg mb-1">{{data.item.name}}</p>
                                <p class="mb-0 text-muted fs-sm fw-300">+{{data.item.mobile}}</p>
                            </div>
                        </div>
                        
                    </template>
                    <template #cell()="data">
                        <div v-if="data.item.break.length != 0">
                            <div v-for="(b) in data.item.break" :key="b.breakID">
                                <button v-if="b.breakDate.toString() == data.field.key" type="button" class="m-2 btn text-left text-nowrap" :class="b.rejectedDate == 0 && b.approvedDate == 0 ? 'btn-warning' : b.rejectedDate == 0 ? 'btn-outline-primary' : 'btn-outline-danger'" @click="toggleStaffActionForm(data.item, data.field.key)">
                                    <span class="fs-lg mt-2 fas mr-1" 
                                        :class="b.rejectedDate == 0 && b.approvedDate == 0 ? 'fa-exclamation-circle' : b.rejectedDate == 0 ? 'fa-check-circle' : 'fa-times-circle'">
                                    </span>
                                    {{b.DfBreakTypeTitle}}
                                    <div v-if="!(b.rejectedDate == 0 && b.approvedDate == 0)" class="mt-2 mb-2 d-block fs-xs fw-300">
                                        <span class="d-block">{{$t(`label.${b.rejectedDate == 0 ? 'approved': 'rejected'}`)}}: </span>
                                        <span>{{b.rejectedDate == 0 ? convertTimestampToDateTime(b.approvedDate) : convertTimestampToDateTime(b.rejectedDate)}}</span>
                                    </div>
                                    <div v-else class="mt-2 mb-2 d-block text-center">
                                        <span class="fw-300 d-block badge bg-white text-dark">{{$t('outlet_setting.roster.pending')}}</span>
                                    </div>
                                </button>
                            </div>
                            <div class="text-center" v-if="filterBreakItem(data.item.break, data.field.key).length == 0">
                                <button v-if="parseInt(data.field.key) < today" type="button" class="w-100 btn btn-lg btn-default btn-calendar-disable"></button>
                                <b-button v-else variant="light" class="m-1 border-0 text-white" @click="toggleStaffForm(data.item, data.field.key)">
                                    {{$t('button_link.click_leave')}}
                                </b-button>
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <button v-if="parseInt(data.field.key) < today" type="button" class="w-100 btn btn-lg btn-default btn-calendar-disable"></button>
                            <b-button v-else variant="light" class="m-1 border-0 text-white" @click="toggleStaffForm(data.item, data.field.key)">
                                {{$t('button_link.click_leave')}}
                            </b-button>
                        </div>
                        
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {dateRange} from './../../assets/js/dashboard/utilities'
export default {
    name: "Scheduler", 
    data(){
        let today = moment().startOf('day').unix()
        return{
            fields: [],
            dateHeader: {},
            data: [],
            breakItem: {},
            today: today
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setHeader(this.dateHeader)
        }
    },
    methods:{
        getIcon(img){
            return img
        },
        convertTimestampToDateTime(date){
            return moment.unix(date).format(this.$msg.CST.DATE_TIME_24)
        },
        sortTable(a, b, key){
            if(key == "staff"){
                return a.name.localeCompare(b.name);
            }
            return false
        },
        filterBreakItem(item, date){
            var filtered = item.filter(obj=> obj.breakDate.toString() == date)
            this.breakItem = filtered[0]
            return filtered
        },
        setScheduler(dateHeader, data){
            this.dateHeader = dateHeader
            this.data = data
            this.setHeader(dateHeader)
        },
        setHeader(dateHeader){
            this.fields = []
            this.fields.push(
                {key: "staff", label: this.$i18n.t('subMenu.salon_setting_staff'), thClass: 'thead-themed align-middle', tdClass:'border-right-3 width-15 align-middle', sortable: true, stickyColumn: true}
            )
            const range = dateRange(moment(dateHeader.startDate).toDate(), moment(dateHeader.endDate).toDate());
            for(var i=0; i<range.length; i++){
                this.fields.push({
                    key: (moment(range[i]).unix() + 28800).toString(),
                    label: moment(range[i]).locale(this.$i18n.locale).format('ddd, DD/MM/YYYY'),
                    thClass: 'thead-themed align-middle text-nowrap',
                    tdClass: 'align-middle p-0'
                })
            }
        },
        toggleStaffForm(obj, date){
            this.$emit('toggleStaffForm', obj, date)
        },
        toggleStaffActionForm(obj, date){
            this.$emit('toggleStaffActionForm', obj, date)
        }
    }
}
</script>
<style>
.border-right-3{
    border-right-width:  3px !important;
}
.btn-calendar-disable{
    background-color: #c5c5c5 !important;
    min-height: 8em;
    border: none !important;
    border-radius: 0;
    cursor: not-allowed !important;
}
</style>
